export default "__VITE_ASSET__xMRYQFYg__"